import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RimsPhaseInfo, RimsStepSchema } from '@app/models/rims.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class RimsService {
  private readonly apiService = inject(ApiService);

  public getRimsPhaseInfos(): Observable<RimsPhaseInfo[]> {
    const resourceUrl = `rims/rimsPhaseInfos`;
    return this.apiService.getJson<RimsPhaseInfo[]>(resourceUrl, void 0, 'RimsPhaseInfos');
  }

  public getRimsStepSchema(stepId: string, skipLoadingSpinner = false): Observable<RimsStepSchema> {
    const resourceUrl = `rims/rimsStepSchema/${stepId}`;
    return this.apiService.getJson<RimsStepSchema>(resourceUrl, void 0, 'RimsStepSchema', skipLoadingSpinner);
  }
}
